import {MIN_SEARCH_LENGTH} from '../../consts';

import {FIELD_NAME, FIELD_EMAIL, FIELD_PHONE, FIELD_DESCRIPTION, FIELD_ROLE} from './consts';
import type {ContactFormFieldTypes} from './types';

export const shouldShowPotentialContacts = (
    name: string | null | undefined,
    description: string | null | undefined,
    phoneNumber: string | null | undefined,
    email: string | null | undefined,
    hasRelatedAccounts: boolean
) => {
    return (
        hasRelatedAccounts ||
        (name && name.length >= MIN_SEARCH_LENGTH) ||
        (description && description.length >= MIN_SEARCH_LENGTH) ||
        (phoneNumber && phoneNumber.length >= MIN_SEARCH_LENGTH) ||
        (email && email.length >= MIN_SEARCH_LENGTH)
    );
};

export const shouldAllowCreate = (
    isTemporary: boolean,
    name?: string | null,
    phoneNumber?: string | null,
    email?: string | null
) => {
    return (
        !isTemporary &&
        ((name && name.length >= MIN_SEARCH_LENGTH) ||
            (phoneNumber && phoneNumber.length >= MIN_SEARCH_LENGTH) ||
            (email && email.length >= MIN_SEARCH_LENGTH))
    );
};

export const handleKeyboardNavigation = (
    e: React.KeyboardEvent,
    showRoleField: boolean,
    showDescriptionField: boolean,
    currentField: ContactFormFieldTypes,
    emailRef: React.RefObject<HTMLInputElement | null | undefined | null>,
    phoneRef: React.RefObject<HTMLInputElement | null | undefined | null>,
    descriptionRef: React.RefObject<HTMLInputElement | null | undefined | null>,
    roleRef: React.RefObject<HTMLInputElement | null | undefined | null>,
    nameRef: React.RefObject<HTMLInputElement | null | undefined | null>
) => {
    switch (e.key) {
        case 'ArrowDown':
            if (currentField === FIELD_NAME) {
                if (showDescriptionField) {
                    descriptionRef.current?.focus();
                } else if (showRoleField) {
                    roleRef.current?.focus();
                } else {
                    phoneRef.current?.focus();
                }
            }
            if (currentField === FIELD_DESCRIPTION) {
                if (showRoleField) {
                    roleRef.current?.focus();
                } else {
                    phoneRef.current?.focus();
                }
            }
            if (currentField === FIELD_ROLE) phoneRef.current?.focus();
            if (currentField === FIELD_PHONE) emailRef.current?.focus();
            if (currentField === FIELD_EMAIL) nameRef.current?.focus();

            break;
        case 'ArrowUp':
            if (currentField === FIELD_NAME) emailRef.current?.focus();
            if (currentField === FIELD_DESCRIPTION) nameRef.current?.focus();
            if (currentField === FIELD_ROLE) {
                if (showDescriptionField) {
                    descriptionRef.current?.focus();
                } else {
                    nameRef.current?.focus();
                }
            }
            if (currentField === FIELD_PHONE) {
                if (showRoleField) {
                    roleRef.current?.focus();
                } else if (showDescriptionField) {
                    descriptionRef.current?.focus();
                } else {
                    nameRef.current?.focus();
                }
            }
            if (currentField === FIELD_EMAIL) phoneRef.current?.focus();

            break;
    }
};
